// Public-bundle-safe docs nav label.
//
// The public splash and top-nav only need the localized word for
// "Docs", they never render any provider/partner/API/settlement
// docs copy directly. Anything richer than that label belongs in
// audience-gated section content (see sections/*.content.ts), or in
// server-enforced approved-provider / admin paths.
//
// Importing a larger docs-copy module from App.tsx historically
// dragged unrelated partner/OpenAPI/webhook/settlement strings into
// the public SPA bundle even when the UI only consumed `.navLabel`.
// Keeping the public surface this small is intentional, adding more
// fields here should require an audience-gating review.

import type { SupportedLocale } from "../i18n";

const NAV_LABELS: Record<SupportedLocale, string> = {
  en: "Docs",
  es: "Docs",
  fr: "Docs",
  de: "Docs",
  pt: "Docs",
  "zh-Hans": "文档",
  ja: "ドキュメント",
  ko: "문서",
  ar: "الوثائق",
  hi: "दस्तावेज़",
  ms: "Dokumentasi"
};

export function docsNavLabel(locale: SupportedLocale): string {
  return NAV_LABELS[locale] ?? NAV_LABELS.en;
}
